/* Fablex V9 enhancements. Never changes native product form, variant selection or availability. */
(()=>{'use strict';
 const root=window.Shopify?.routes?.root||'/';
 const money=(p,currency)=>new Intl.NumberFormat('en-GB',{style:'currency',currency:currency||'GBP'}).format(p/100);
 let requestId=0;
 async function syncDelivery(){
   if(!document.querySelector('[data-fv8-shipping],[data-fv9-pair-shipping]'))return;
   const thisRequest=++requestId;
   try{
     const res=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
     if(!res.ok)throw new Error('cart fetch failed');
     const cart=await res.json();if(thisRequest!==requestId)return;
     const amount=cart.items_subtotal_price ?? cart.total_price;
     // Shopify uses shop currency for this cart. Checkout eligibility/rates are authoritative.
     const currency=cart.currency||'GBP';
     document.querySelectorAll('[data-fv8-shipping]').forEach(bar=>{
       const threshold=Number(bar.dataset.threshold)||7000;
       const remaining=Math.max(0,threshold-amount);
       const percent=Math.min(100,Math.max(0,100*amount/threshold));
       const fill=bar.querySelector('[data-fv8-fill]');
       const status=bar.querySelector('[data-fv8-status]');
       const role=bar.querySelector('[role="progressbar"]');
       if(fill)fill.style.width=percent+'%';
       if(status)status.textContent=remaining?money(remaining,currency)+' to go':'✦ Free shipping unlocked';
       if(role){role.setAttribute('aria-valuenow',(Math.min(threshold,amount)/100).toFixed(2));role.setAttribute('aria-valuetext',remaining?money(remaining,currency)+' remaining':'Free UK standard shipping threshold reached');}
       bar.classList.toggle('is-unlocked',remaining===0);
     });
     document.querySelectorAll('[data-fv9-pair-shipping]').forEach(el=>{
       const remaining=Math.max(0,7000-amount);
       el.textContent=remaining?`Add ${money(remaining,currency)} more to your cart for free UK standard shipping.`:'✦ Your cart has reached the free UK standard shipping threshold.';
     });
   }catch(e){document.querySelectorAll('[data-fv8-status]').forEach(el=>{el.textContent='Free shipping at £70';});}
 }
 function scheduleDelivery(delay=170){setTimeout(syncDelivery,delay);}
 function initVariantDisclosures(){
   document.querySelectorAll('.product-information variant-picker[data-template-product-match="true"]').forEach(picker=>{
     if(picker.dataset.fv9ToggleReady)return;
     picker.dataset.fv9ToggleReady='true';
     const id=picker.id||('fv9-variant-'+(picker.dataset.productId||'product'));
     picker.id=id;
     const text=picker.querySelector('.variant-option legend')?.textContent?.trim()||'Product options';
     const btn=document.createElement('button');btn.type='button';btn.className='fv9-variant-toggle';
     btn.setAttribute('aria-controls',id);btn.setAttribute('aria-expanded','true');
     btn.innerHTML='<span>Choose '+text.replace(/[<>]/g,'')+'</span><span aria-hidden="true">−</span>';
     picker.before(btn);
     btn.addEventListener('click',()=>{
       const open=btn.getAttribute('aria-expanded')!=='true';
       picker.classList.toggle('fv9-variant-is-collapsed',!open);
       btn.setAttribute('aria-expanded',String(open));
       btn.querySelector('[aria-hidden]')?.replaceChildren(document.createTextNode(open?'−':'+'));
     });
   });
 }
 function initCarousel(){
   document.querySelectorAll('[data-fv8-pairings]').forEach(section=>{
     if(section.dataset.fv9CarouselReady)return;section.dataset.fv9CarouselReady='true';
     const list=section.querySelector('.fv9-pairings__carousel');if(!list)return;
     const scroll=(sign)=>list.scrollBy({left:sign*(list.querySelector('.fv8-pair')?.getBoundingClientRect().width||180)+sign*12,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
     section.querySelector('[data-fv9-pair-prev]')?.addEventListener('click',()=>scroll(-1));
     section.querySelector('[data-fv9-pair-next]')?.addEventListener('click',()=>scroll(1));
   });
 }
 function init(){initCarousel();initVariantDisclosures();syncDelivery();}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
 // This is the EXACT event name emitted by the underlying Shopify Horizon theme.
 document.addEventListener('shopify:cart:lines-update',event=>{
   if(event.promise && typeof event.promise.then==='function'){
     event.promise.then(()=>syncDelivery()).catch(()=>scheduleDelivery(300));
   } else scheduleDelivery(350);
 });
 document.addEventListener('fablex:cart-updated',()=>scheduleDelivery(150));
 document.addEventListener('cart:updated',()=>scheduleDelivery(150));
 document.addEventListener('cart:refresh',()=>scheduleDelivery(150));
 window.addEventListener('pageshow',()=>scheduleDelivery(100));
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)scheduleDelivery(150)});
 // Fallback: native/ajax cart requests from other apps might not publish theme events.
 const nativeFetch=window.fetch;
 window.fetch=function(...args){
   const url=typeof args[0]==='string'?args[0]:args[0]?.url||'';
   const method=(args[1]?.method||args[0]?.method||'GET').toUpperCase();
   const isMutation=method!=='GET'&&/\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url);
   const promise=nativeFetch.apply(this,args);
   if(isMutation)promise.then(response=>{if(response.ok){scheduleDelivery(110);scheduleDelivery(850);}}).catch(()=>{});
   return promise;
 };
})();
